import { Component, OnInit, HostListener, ViewChildren, ElementRef, ViewChild, Input } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { EDictateService } from '../e-dictate.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Guid } from '../../core/guid';
import { AutofocusDirective } from '../../shared/directives/autofocus.directive';
import { PictureService } from '../../picture/picture.service';
import { AttachmentService } from '../../attachment/attachment.service';

@Component({
  selector: 'app-applicationauth',
  templateUrl: './applicationauth.component.html',
  styleUrls: ['./applicationauth.component.css']
})
export class ApplicationauthComponent implements OnInit {
    OTPNumber: any;
    showCodeEntry: boolean = false;
    showLoading: boolean = false;
    authForm: FormGroup;
    message: string;
    isError: boolean;
    isAlert: boolean;
    isWarning: boolean;
    isAlertSuccess: boolean;
    isAlertWarnSuccess: boolean;
    isExpAlertSuccess: boolean;
    isAuthEnable: boolean;
    attemptCount: number= 0;
    signnewid: Guid;
    optValue: any;
    currentPage: string;
    urlType: string;
    headerTitle: string;
    formInput = ['input1', 'input2', 'input3', 'input4', 'input5', 'input6'];
    isSingle:boolean = false;
    @ViewChildren('formRow') rows: any;
   

    constructor(private EDictateService: EDictateService,
        private route: ActivatedRoute,
        private fb: FormBuilder,
        private router: Router,
        private PictureService: PictureService,
        private AttachmentService: AttachmentService) {
        var signImg = ''
        route.params.subscribe(val => {
            let id = (this.route.snapshot.params['signId']) ? this.route.snapshot.params['signId'] : '';
                       this.signnewid = id;
            this.authForm = this.toFormGroup(this.formInput);
            let url = this.router.url;
            this.urlType = url.toString().split('/')[1];
        });

        route.queryParams.subscribe(val => {
            console.log(val.single);
            this.isSingle = val.single=="true" ? true : false ;            //#added for CRM 161337 
            console.log(this.isSingle);     
        });
       
    }
    toFormGroup(elements) {
        const group: any = {};

        elements.forEach(key => {
            group[key] = new FormControl('', Validators.required);
        });
        return new FormGroup(group);
    }
    @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
        e.preventDefault();
    }

    
    ngOnInit() {
        this.isAlertWarnSuccess = false;
        this.isAlertSuccess = false;
        this.isExpAlertSuccess = false;
        this.isAuthEnable = false;        
        if (this.urlType == 'text') {
            this.headerTitle = "Phoenix Text";
            this.isValidText(this.signnewid);

        }
        else if (this.urlType == 'Picture') {
            this.headerTitle = "Phoenix Link";
            this.isValidPicture(this.signnewid);

        } else if (this.urlType == 'Attachment') {
            this.headerTitle = "Phoenix Attachment";
            this.isValidAttachment(this.signnewid);

        }
        
        //this.formGroup();

       
    }
    isValidText(id) {
        if (id != "") {
            this.EDictateService.getisValidSign(id)
                .then(response => {
                    this.isAuthEnable = false;
                    if (response) {                        
                        this.OTPNumber = response.AuthCode;
                        this.showLoading = true;
                        if (response.IsValid == true) {
                            if (response.TextData != null) {
                                this.isAuthEnable = true;
                                //this.showAlert("Not Authorized", true, true);
                                console.log("Already Submitted");
                                this.isExpAlertSuccess = true;
                            }

                        } else {
                            this.invalidResponse();
                            console.log("Time out", response.IsValid);
                        }
                    } else {
                        this.invalidResponse();
                        console.log("Signature ID InValid");
                    }
                }).catch(error => {
                    this.showAlert(error, true);
                    this.showLoading = false;
                });
        } else {
            this.signIDValidate(id);
            console.log("Signature ID InValid in onload");
        }
    }
    isValidPicture(id) {
        if (id != "") {            
            this.PictureService.getisValidSign(id)
                .then(response => {
                    this.isAuthEnable = false;
                    if (response) {
                        this.OTPNumber = response.AuthCode;
                        this.showLoading = true;
                        if (response.IsValid == true) {
                            if (response.Custom2 == '1') {
                                this.isAuthEnable = true;
                                //this.showAlert("Not Authorized", true, true);
                                console.log("Already Submitted");
                                this.isExpAlertSuccess = true;
                            }

                        } else {
                            this.invalidResponse();
                            console.log("Time out", response.IsValid);
                        }
                    } else {
                        this.invalidResponse();
                        console.log("Signature ID InValid");
                    }
                }).catch(error => {
                    this.showAlert(error, true);
                    this.showLoading = false;
                });
        } else {
            this.signIDValidate(id);
            console.log("Signature ID InValid in onload");
        }
    }
    isValidAttachment(id) {
        if (id != "") {
            this.AttachmentService.getisValidSign(id)
                .then(response => {
                    this.isAuthEnable = false;
                    if (response) {
                        this.OTPNumber = response.AuthCode;
                        this.showLoading = true;
                        if (response.IsValid == true) {
                            if (response.Custom2 == '1') {
                                this.isAuthEnable = true;
                                //this.showAlert("Not Authorized", true, true);
                                console.log("Already Submitted");
                                this.isExpAlertSuccess = true;
                            }

                        } else {
                            this.invalidResponse();
                            console.log("Time out", response.IsValid);
                        }
                    } else {
                        this.invalidResponse();
                        console.log("Signature ID InValid");
                    }
                }).catch(error => {
                    this.showAlert(error, true);
                    this.showLoading = false;
                });
        } else {
            this.signIDValidate(id);
            console.log("Signature ID InValid in onload");
        }
    }
    signIDValidate(id) {
        if (id == "") {
            
            this.isAuthEnable = true;
            this.isAlertSuccess = true;

            //this.showAlert("Not Authorized", true, true);

        }
    }

    invalidResponse() {
       
        this.isAuthEnable = true;
        this.isAlertSuccess = true;
        //this.showAlert("Not Authorized", true, true);
    }
    onSeeTextEntry() {
        this.showCodeEntry = true;
    }
    //move(e: any, p: any, c: any, n: any) {
    //    debugger
    //    var length = c.length;
    //    var maxlength = c.getAttribute(maxlength);
    //    if (length == maxlength) {
    //        if (n != "") {
    //            n.focus();
    //        }
           
    //    }
    //    if (e.keyCode === 8 && e.which === 8) {
    //        if (p != "") {
    //            p.focus();

    //        }
    //        else {
    //            c.focus();
    //        }
    //    }

    //}
    //move(e: any, p: any, c: any, n: any) {
    //    debugger
    //    let getInputOTP;
    //    var length = c.length;
    //    var maxlength = c.getAttribute(maxlength);
    //    if (length == maxlength) {
    //        if (n != "") {
    //            n.focus();
    //        }

    //    }
    //    if (e.keyCode === 8 && e.which === 8) {
    //        if (p != "") {
    //            p.focus();

    //        }
    //        else {
    //            c.focus();
    //        }
    //    }

    //    this.showLoading = true;

    //    if (this.authForm.value.input1 != null && this.authForm.value.input2 != null && this.authForm.value.input3 != null && this.authForm.value.input4 != null && this.authForm.value.input5 != null && this.authForm.value.input6 != null) {

    //        getInputOTP = this.authForm.value.input1.toString() + this.authForm.value.input2.toString() + this.authForm.value.input3.toString() + this.authForm.value.input4.toString() + this.authForm.value.input5.toString() + this.authForm.value.input6.toString();


    //    }

    //    if (getInputOTP != null) {
    //        if (pos > -1 && pos < this.formInput.length) {
    //            this.showLoading = true;
    //        }
    //        if (pos == 6) {

    //            if (getInputOTP == this.OTPNumber) {

    //                this.showLoading = false;
    //                if (this.urlType == 'text') {
    //                    this.router.navigate(['text', this.signnewid]);
    //                }
    //                else if (this.urlType == 'Picture') {
    //                    this.router.navigate(['Picture', this.signnewid]);
    //                }

    //            }
    //            else {
    //                this.attemptCount++;
    //                if (this.attemptCount == 3) {

    //                    this.showLoading = true;
    //                    this.isAuthEnable = true;
    //                    this.isAlertWarnSuccess = false;
    //                    this.isAlertSuccess = true;
    //                    //this.showAlert("Not Authorized", true, true);
    //                }
    //                else {

    //                    this.showLoading = true;
    //                    this.rows._results[pos - 6].nativeElement.focus();
    //                    this.authForm.reset();
    //                    this.isAlertWarnSuccess = true;
    //                    this.showAlert("Entered Code is incorrect, Please enter valid Code", true, true);
    //                    this.isAlertWarnSuccess = true;
    //                    this.isAlertSuccess = false;
    //                    this.showLoading = false;
    //                }

    //            }
    //        }
    //        this.showLoading = false;
    //    }




    //}

    onKeyupCode(event, index) {    
        
        let getInputOTP; 
        let pos = index;
        
            if (event.keyCode === 8 && event.which === 8) {
                pos = index - 1;
            } else {
                pos = index + 1;
            }
            if (pos > -1 && pos < this.formInput.length) {
                this.rows._results[pos].nativeElement.focus();
            }

            this.showLoading = true;

            if (this.authForm.value.input1 != null && this.authForm.value.input2 != null && this.authForm.value.input3 != null && this.authForm.value.input4 != null && this.authForm.value.input5 != null && this.authForm.value.input6 != null) {

                getInputOTP = this.authForm.value.input1.toString() + this.authForm.value.input2.toString() + this.authForm.value.input3.toString() + this.authForm.value.input4.toString() + this.authForm.value.input5.toString() + this.authForm.value.input6.toString();
               

            }

            if (getInputOTP != null) {
                if (pos > -1 && pos < this.formInput.length) {
                    this.showLoading = true;
                }
                if (pos == 6) {

                    if (getInputOTP == this.OTPNumber) {

                        this.showLoading = false;
                        if (this.urlType == 'text') {
                            this.router.navigate(['text', this.signnewid]);
                        }
                        else if (this.urlType == 'Picture') {
                            this.router.navigate(['Picture', this.signnewid],{ queryParams: { single: this.isSingle} });
                        }
                        else if (this.urlType == 'Attachment') {
                            this.router.navigate(['Attachment', this.signnewid]);
                        }
                        
                    }
                    else {
                        this.attemptCount++;
                        if (this.attemptCount == 3) {

                            this.showLoading = true;
                            this.isAuthEnable = true;
                            this.isAlertWarnSuccess = false;
                            this.isAlertSuccess = true;
                            this.isExpAlertSuccess = false;
                            //this.showAlert("Not Authorized", true, true);
                        }
                        else {

                            this.showLoading = true;
                            this.rows._results[pos - 6].nativeElement.focus();
                            this.authForm.reset();
                            this.isAlertWarnSuccess = true;
                            this.showAlert("Entered Code is incorrect, Please enter valid Code", true, true);
                            this.isAlertWarnSuccess = true;
                            this.isAlertSuccess = false;
                            this.showLoading = false;
                            this.isExpAlertSuccess = false;
                        }

                    }
                }
                this.showLoading = false;
            }
           
        
        

    }
  
    onChangeCode(event) {
        
        this.showLoading = true;
        //let getInputOTP = parseInt(this.PDFForm.controls.EnteredOtp.value);

        if (this.formInput.length > 0 && this.formInput.length < 6) {
            this.showLoading = true;
            this.showAlert("Please enter valid OTP", true, true);
        }
        this.showLoading = false;

    }
    numberOnly(event: any, value: any): boolean {
        this.optValue = event.key
        if (value === "percentage" && event.key === ".") {
            return true
        } else {
            const charCode = (event.which) ? event.which : event.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                return false;
            }
            return true;
        }
    }


    // Show Alert

    showAlert(strMsg: string, isErr: boolean, showWarning: boolean = false) {
        this.isAlert = true;
        this.isError = isErr;
        this.isWarning = showWarning;
        this.message = strMsg;
    }

    // Close Alert

    closeAlert() {
        this.isAlert = false;
    }

    CloseSuccess() {
        window.close();
    }

}



// WEBPACK FOOTER //
// ./SignClient/app/e-dictate/applicationauth/applicationauth.component.ts